import * as React from 'react';

const ChevronSmall = (props) => (
    <svg
        {...props}
        fill='none'
        height={16}
        viewBox='0 0 16 16'
        width={16}
        xmlns='http://www.w3.org/2000/svg'>
        <g
            clipPath='url(#clip0_704_1507)'>
            <path
                d='M5.48374 14.384L11.0721 8.79559C11.5115 8.35625 11.5115 7.64394 11.0721 7.2046L5.48349 1.61597L4.59961 2.49985L10.0999 8.00009L4.59985 13.5001L5.48374 14.384Z'
                fill='currentColor'/>
        </g>
        <defs>
            <clipPath id='clip0_704_1507'>
                <rect
                    fill='white'
                    height='16'
                    width='16'/>
            </clipPath>
        </defs>

    </svg>
);

export default ChevronSmall;
